import { render, staticRenderFns } from "./serviceCloud1.vue?vue&type=template&id=118d3a78&scoped=true"
import script from "./serviceCloud1.vue?vue&type=script&lang=js"
export * from "./serviceCloud1.vue?vue&type=script&lang=js"
import style0 from "./serviceCloud1.vue?vue&type=style&index=0&id=118d3a78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d3a78",
  null
  
)

export default component.exports